itsoftApp.createModule("createCircle", function () {
    var module = this;
    // var libraryLoaded = false;

    var initCircle = function () {
        itsoftApp.loadScript("/assets/scripts/progressbar/progressbar.min.js", function () {
            var createCircle = function (wrapper) {
                var element = wrapper.querySelector(".js-circle");
                var textElement = wrapper.querySelector(".js-circle-text"); 
                var currentValue = element.getAttribute("data-current-value");
                var endValue = element.getAttribute("data-end-value");

                var settings = {
                    strokeWidth: 50,
                    color: "#00B0A8",
                    easing: "easeInOut",
                    duration: 5000,
                    svgStyle: {
                        display: "block",
                        width: "100%"
                    },
                    fill: null,
                    step: function(state, circle, attachment) {
                        var value = Math.round(circle.value() * endValue);
                        textElement.textContent = value;
                    }
                };

                var progressBar = new ProgressBar.Circle(element, settings);
                progressBar.animate(1);
            }

            var circleElements = document.querySelectorAll(".js-circle-wrapper");

            Array.prototype.forEach.call(circleElements, function (element) {
                createCircle(element);
            });
        });
    }

    module.callback = initCircle;
});